//angular imports
import {
    ChangeDetectionStrategy,
    Component
} from '@angular/core';

// ngx-imports
import { Toast } from 'ngx-toastr';

// local imports

import { ToastAnimation } from './animation';

@Component({
    selector: '[toast-component]',
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss',
    animations: [ToastAnimation],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
    preserveWhitespaces: true,
})
export class ToastComponent extends Toast {


}


